export default __webpack_public_path__ + "images/pages/regimen_finder/skin_types/oily-5f912c1073bd7794f902f304bb8d84e0.svg";